module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Ga-Ha-Ia-Gc.d06527b6.png";